import {
  AuthTokenNotSetError,
  UnknownApiError,
} from './errors';

export default function (api) {
  /**
   * @memberof API
   * @instance
   */
  const playback = {
    /**
     * Clear the user's registered device list.
     * Auth token is required.
     *
     * @method
     * @this API
     *
     * @return {Promise}
     * @reject {AuthTokenNotSetError}
     * @reject {UnknownApiError}
     */
    resetDevices: async function resetDevices() {
      if (!this.authData) {
        throw new AuthTokenNotSetError();
      }

      const res = await this.request('delete', '/playback/v1/devices');

      switch (res.status) {
        case 200: {
          return res.body;
        }
        default: {
          throw new UnknownApiError(undefined, res);
        }
      }
    }.bind(api),
  };

  return playback;
}
